export default __webpack_public_path__ + "static/media/novena.bb3bd156.jpg";